export default "__VITE_ASSET__C3XLyN89__"